import { render } from "./SuiviReclamationPage.vue?vue&type=template&id=abb6cf54&scoped=true&ts=true"
import script from "./SuiviReclamationPage.vue?vue&type=script&lang=ts"
export * from "./SuiviReclamationPage.vue?vue&type=script&lang=ts"

import "./SuiviReclamationPage.vue?vue&type=style&index=0&id=abb6cf54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb6cf54"]])

export default __exports__